import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ArticleCard = ({ id, title, excerpt, imageUrl, date, readTime, category }) => {
  return (
    <div className="h-100">
      <Link to={`/articles/${id}`} style={{ textDecoration: 'none' }}>
        <Card className="article-card border-0 h-100">
          <div
            style={{
              height: '220px',
              background: `url(${imageUrl}) center/cover no-repeat`,
              position: 'relative'
            }}
          >
            {category && (
              <span
                style={{
                  position: 'absolute',
                  top: '14px',
                  left: '14px',
                  background: 'rgba(16, 41, 31, 0.8)',
                  color: '#f5f2ea',
                  borderRadius: '6px',
                  padding: '6px 12px',
                  fontSize: '0.72rem',
                  fontWeight: '700',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase'
                }}
              >
                {category}
              </span>
            )}
          </div>
          <Card.Body className="p-4 d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="text-muted">{date}</small>
              <small className="text-muted">{readTime} min read</small>
            </div>
            <h4 className="h5 mb-3" style={{ color: 'var(--primary-green)' }}>
              {title}
            </h4>
            <p className="text-muted mb-0 flex-grow-1" style={{ fontSize: '0.9rem' }}>
              {excerpt}
            </p>
            <div className="mt-3">
              <span style={{
                color: 'var(--muted-gold)',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}>
                Read More →
              </span>
            </div>
          </Card.Body>
        </Card>
      </Link>
    </div>
  );
};

export default ArticleCard;